var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isInitializing())?_c('div',[_c('v-progress-circular',{staticClass:"mt-6",attrs:{"indeterminate":"","width":"2"}})],1):(_vm.isLoggedIn())?_c('Portal'):_c('EntranceView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }